import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import instance from "core/constants/request";
import { MAG_HOME_END_POINTS } from "core/constants/endpoints";

const getMagHomeSliders = async (): Promise<any> => {
  const res = await instance.get(MAG_HOME_END_POINTS.sliders_list);

  return res.data;
};

type optionsType = UseQueryOptions<any, unknown, any>;
export const useGetMagHomeSliders = (config?: optionsType) => {
  return useQuery({
    queryKey: [MAG_HOME_END_POINTS.sliders_list],
    queryFn: getMagHomeSliders,
    ...config,
  });
};
